import { Features } from '@lessonPlanner/constants';

import { FeatureMenuItem, MenuItem } from '../types/menu-item';

export interface RouteItem {
  label: string;
  link: string;
  featureKey: Features;
  isNewFeature?: boolean;
}

export const mapRouteToMenuItem = (
  route: RouteItem,
  premiumRoutes: string[],
): FeatureMenuItem => ({
  type: MenuItem.FEATURE,
  name: route.label,
  href: route.link,
  isNew: route.isNewFeature || false,
  isPremium: premiumRoutes.includes(route.link),
});
